<app-menu [organisation]="organisation" [screen]="screen" (menuEvent)="handleFunctionEvent($event)"></app-menu>

<div class="help-container" [class.reading]="slug">
    <mat-card appearance="raised" class="page-header">
        <div class="title-row">
            <div>
                <h2><a [routerLink]="link()" class="home-link">Help guides</a></h2>
                <p class="page-description">How LINQ works and how to use it. Search the guides, or ask LINQ AI.</p>
            </div>
            <button mat-stroked-button type="button" (click)="askAI()" class="ask-ai">
                <mat-icon>forum</mat-icon>Ask LINQ AI
            </button>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Search the guides</mat-label>
            <input matInput [formControl]="search" type="search" autocomplete="off" data-testid="help-search" maxlength="200">
            @if (search.value) {
                <button matSuffix mat-icon-button type="button" (click)="clearSearch()" aria-label="Clear the search">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>
    </mat-card>

    @if (!loaded) {
        <spinner-overlay [overlay]="true"></spinner-overlay>
    }@else if (failed) {
        <mat-card appearance="raised" class="message" role="alert">The guides couldn't be loaded. Try again in a moment.</mat-card>
    }@else {
        <div class="library">
            <!-- the guides: a directory when none is open, or a list beside the open one -->
            <nav class="guide-list" [class.directory]="!slug" aria-label="Help guides">
                @if (results) {
                    <div class="results-heading" role="status">
                        @if (searching && !results.length) { Searching… }
                        @else { {{results.length}} guide{{results.length === 1 ? '' : 's'}} found }
                    </div>
                    @for (r of results; track r.guide.slug) {
                        <a class="guide-link" [routerLink]="link(r.guide.slug)" [class.active]="r.guide.slug === slug" data-testid="help-result">
                            <span class="guide-title">{{r.guide.title}}</span>
                            <span class="guide-category">{{r.guide.category}}</span>
                            <span class="guide-summary">{{r.snippet || r.guide.summary}}</span>
                        </a>
                    }@empty {
                        @if (!searching) {
                            <p class="no-results">No guides mention that. Try other words, or <button mat-button type="button" (click)="askAI()">ask LINQ AI</button></p>
                        }
                    }
                }@else {
                    @for (c of categories; track c.name) {
                        <section class="category">
                            <h3>{{c.name}}</h3>
                            <div class="category-guides">
                                @for (g of c.guides; track g.slug) {
                                    <a class="guide-link" [routerLink]="link(g.slug)" [class.active]="g.slug === slug" data-testid="help-guide-link">
                                        <span class="guide-title">{{g.title}}</span>
                                        @if (!slug) {
                                            <span class="guide-summary">{{g.summary}}</span>
                                        }
                                    </a>
                                }
                            </div>
                        </section>
                    }
                }
            </nav>

            @if (slug) {
                <mat-card appearance="raised" class="guide" #article>
                    <a [routerLink]="link()" class="back-link"><mat-icon>arrow_back</mat-icon>All guides</a>
                    @if (guideLoading) {
                        <spinner-overlay [overlay]="true"></spinner-overlay>
                    }@else if (guideMissing) {
                        <p role="alert">This guide couldn't be found. Choose another from the list.</p>
                    }@else if (guide) {
                        <article data-testid="help-guide">
                            <div class="guide-category">{{guide.category}}</div>
                            <h1>{{guide.title}}</h1>
                            @if (videoUrl(guide); as url) {
                                <app-video class="guide-video" [videoUrl]="url"></app-video>
                            }
                            <div class="guide-content" [innerHTML]="guide.html"></div>
                        </article>
                        <footer class="guide-nav">
                            @if (neighbour(-1); as previous) {
                                <a [routerLink]="link(previous.slug)" class="previous"><mat-icon>chevron_left</mat-icon>{{previous.title}}</a>
                            }
                            <span class="spacer"></span>
                            @if (neighbour(1); as next) {
                                <a [routerLink]="link(next.slug)" class="next">{{next.title}}<mat-icon>chevron_right</mat-icon></a>
                            }
                        </footer>
                    }
                </mat-card>
            }
        </div>
    }
</div>
